import React from 'react';

import type { ToastStore } from 'widget/stores/ToastStore';

const ToastStoreContext = React.createContext<ToastStore | null>(null);

export const ToastStoreProvider = ToastStoreContext.Provider;

export const useToastStore = (): ToastStore | null => {
  return React.useContext(ToastStoreContext);
};
